// API for feature / change requests — the submit form, the floating prompt,
// and the admin dashboard.
const jsonRequest = async (url, options = {}) => {
  const res = await fetch(url, {
    ...options,
    // Merged rather than replaced so callers can add headers (the admin
    // calls add x-user-id) without dropping the JSON content type.
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      ...(options.headers || {}),
    },
  });
  const content = await res.json();
  if (!res.ok) throw new Error(content.error || "Request failed");
  return content;
};

// The admin endpoints identify the caller by this header (no token
// validation server-side — it's the same trust model the door kit admin
// routes use), so every admin call needs the signed-in user's id.
const adminRequest = (url, userId, options = {}) =>
  jsonRequest(url, {
    ...options,
    headers: { "x-user-id": userId || "" },
  });

export const REQUEST_TYPES = [
  "New Feature",
  "Change to Something Existing",
  "Something Is Broken",
  "Other",
];

export const PRIORITIES = [
  "Nice to have",
  "Would help a lot",
  "Blocking my work",
];

export const submitFeatureRequest = (payload) =>
  jsonRequest("/api/feature-requests", {
    method: "POST",
    body: JSON.stringify(payload),
  });

// The submitter's own requests, so they can see where earlier asks landed.
export const fetchMyFeatureRequests = (email) =>
  jsonRequest(`/api/feature-requests/mine?email=${encodeURIComponent(email)}`);

// ---- Admin ----

// List of all requests (screenshots excluded — use fetchFeatureRequest).
export const fetchFeatureRequests = (userId) =>
  adminRequest("/api/feature-requests", userId);

export const fetchFeatureRequest = (id, userId) =>
  adminRequest(`/api/feature-requests/${encodeURIComponent(id)}`, userId);

export const updateFeatureRequestStatus = (id, status, updatedBy, userId) =>
  adminRequest(`/api/feature-requests/${encodeURIComponent(id)}/status`, userId, {
    method: "PUT",
    body: JSON.stringify({ status, updatedBy }),
  });

export const addFeatureRequestNote = (id, text, author, userId) =>
  adminRequest(`/api/feature-requests/${encodeURIComponent(id)}/notes`, userId, {
    method: "POST",
    body: JSON.stringify({ text, author }),
  });

export const deleteFeatureRequest = (id, userId) =>
  adminRequest(`/api/feature-requests/${encodeURIComponent(id)}`, userId, {
    method: "DELETE",
  });
